import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class Name extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): Name {
    if (!(value.length > 0)) {
      throw new Error('名前が入力されていません');
    }
    return new Name(value);
  }

  /** ラベル */
  static get label(): string {
    return '名前';
  }

  /** プレースホルダー */
  static get placeholder(): string {
    return '太郎';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }

  /** キー */
  static get key() {
    return 'name';
  }

  /** タイプ */
  static get type() {
    return 'text';
  }

  /** 文字列にする */
  override toString() {
    return this.value;
  }
}
